import styled from 'styled-components';

import { BrandColors, GreenColors } from '@/theme';

import {
  PRODUCT_NAME_BOLD_WEIGHT,
  PRODUCT_NAME_ENVIRONMENT_FONT_SIZE,
  PRODUCT_NAME_ENVIRONMENT_LETTER_SPACING,
  PRODUCT_NAME_FONT_SIZE,
  PRODUCT_NAME_LETTER_SPACING,
  PRODUCT_NAME_LINE_HEIGHT,
  PRODUCT_NAME_REGULAR_WEIGHT,
  TOPBAR_NAVIGATION_ID
} from './constants';
import type { PanoramaProductNameVariant } from './types';

const wordmarkColor = (variant: PanoramaProductNameVariant) =>
  variant === 'dev' ? GreenColors[60] : BrandColors.syngentaNavy;

const wordmarkFontSize = (variant: PanoramaProductNameVariant) =>
  variant === 'default'
    ? PRODUCT_NAME_FONT_SIZE
    : PRODUCT_NAME_ENVIRONMENT_FONT_SIZE;

const wordmarkFontWeight = (variant: PanoramaProductNameVariant) =>
  variant === 'uat' ? PRODUCT_NAME_BOLD_WEIGHT : PRODUCT_NAME_REGULAR_WEIGHT;

const wordmarkLetterSpacing = (variant: PanoramaProductNameVariant) =>
  variant === 'default'
    ? PRODUCT_NAME_LETTER_SPACING
    : PRODUCT_NAME_ENVIRONMENT_LETTER_SPACING;

/**
 * Host override for the Cropwise topbar product name. That micro-frontend
 * renders the name as a direct `h1` and does not accept color or weight.
 */
export const productNameRule = (variant: PanoramaProductNameVariant) =>
  [
    `#${TOPBAR_NAVIGATION_ID} > h1{`,
    "font-family:'Noto Sans',sans-serif;",
    `line-height:${PRODUCT_NAME_LINE_HEIGHT};`,
    `color:${wordmarkColor(variant)};`,
    `font-size:${wordmarkFontSize(variant)};`,
    `font-weight:${wordmarkFontWeight(variant)};`,
    `letter-spacing:${wordmarkLetterSpacing(variant)};`,
    '}'
  ].join('');

export const ProductName = styled.span<{
  $variant: PanoramaProductNameVariant;
}>`
  font-family: 'Noto Sans', sans-serif;
  line-height: ${PRODUCT_NAME_LINE_HEIGHT};
  color: ${({ $variant }) => wordmarkColor($variant)};
  font-size: ${({ $variant }) => wordmarkFontSize($variant)};
  font-weight: ${({ $variant }) => wordmarkFontWeight($variant)};
  letter-spacing: ${({ $variant }) => wordmarkLetterSpacing($variant)};
`;
